import { SelectData } from '@shared/models/select-input.model';

export const PEP_CONDITION_OPTIONS: SelectData[] = [
  { label: 'Não é PEP', value: 'NAO_PEP' },
  { label: 'É PEP', value: 'PEP' },
  { label: 'Familiar de 1º grau de PEP (pai, mãe, cônjuge, filhos)', value: 'FAMILIAR_PEP' },
  { label: 'Estreito colaborador de PEP (sócio ou pessoa com influência política)', value: 'COLABORADOR_PEP' },
];

export const YES_NO_RADIOS = [
  { name: 'Sim', value: true },
  { name: 'Não', value: false },
];

export const BENEFICIAL_OWNER_INFLUENCE_OPTIONS: SelectData[] = [
  { label: 'Participação (cotas ou capital)', value: 'PARTICIPACAO' },
  { label: 'Controle', value: 'CONTROLE' },
  { label: 'Influência significativa', value: 'INFLUENCIA_SIGNIFICATIVA' },
];

export const BENEFICIAL_OWNER_MIN_PARTICIPATION = 25;

export const OWNERSHIP_ENTITY_TYPE_OPTIONS: SelectData[] = [
  { label: 'Pessoa física', value: 'PF' },
  { label: 'Pessoa jurídica', value: 'PJ' },
  { label: 'Fundo de investimento', value: 'FI' },
];

export const FUND_ATTORNEY_RELATIONSHIP_OPTIONS: SelectData[] = [
  { label: 'Procurador', value: 'PROCURADOR' },
  { label: 'Representante legal', value: 'REPRESENTANTE_LEGAL' },
  { label: 'Administrador/Diretor', value: 'ADMINISTRADOR_DIRETOR' },
  { label: 'Outro', value: 'OUTRO' },
];
